"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomaticTabActivator = void 0;
var tslib_1 = require("tslib");
var BaseTabActivator_1 = require("./BaseTabActivator");
/**
 * Automatically activated tabs: tabs are automatically activated and their panel is displayed when they receive focus
 */
var AutomaticTabActivator = /** @class */ (function (_super) {
    tslib_1.__extends(AutomaticTabActivator, _super);
    function AutomaticTabActivator(tabsWidget) {
        return _super.call(this, tabsWidget) || this;
    }
    AutomaticTabActivator.prototype.handleKeyDown = function (tabIndex, keyboardEvent) {
        var nextActiveTabIndex = this.tabIndexFromKeyDown(tabIndex, keyboardEvent.key);
        if (nextActiveTabIndex !== -1) {
            this.tabsWidget.setActiveIndex(nextActiveTabIndex);
            BaseTabActivator_1.BaseTabActivator.preventDefaultAndStopPropagation(keyboardEvent);
        }
    };
    return AutomaticTabActivator;
}(BaseTabActivator_1.BaseTabActivator));
exports.AutomaticTabActivator = AutomaticTabActivator;
//# sourceMappingURL=AutomaticTabActivator.js.map